<script setup lang="ts">
import { backendOld } from "~/api";
import SettingsCopyText from "~/components/settings/SettingsCopyText.vue";
import SettingsRow from "~/components/settings/SettingsRow.vue";
import { useUserStore } from "~/stores";

const ROTATE_AUTH_TOKEN_DIALOG_DESCRIPTION =
  "Rotating the authentication token will invalidate the old token and make a new one. This can't be undone. Are you sure you want to proceed?";
const DELETE_AUTH_TOKEN_DIALOG_DESCRIPTION =
  "Deleting the authentication token will invalidate the old token. This can't be undone. Are you sure you want to proceed?";

const userStore = useUserStore();

const rotateAuthToken = async () => {
  const { data } = await backendOld.profile.rotateAuthToken();
  userStore.authToken = data.authToken;
};

const deleteAuthToken = async () => {
  userStore.authToken = null;
  backendOld.profile.deleteAuthToken();
};
</script>

<template>
  <SettingsRow title="Token" subtitle="Manage your API key, a bearer authentication token" vertical>
    <SettingsCopyText
      :text="userStore.authToken"
      :rotate-dialog-description="ROTATE_AUTH_TOKEN_DIALOG_DESCRIPTION"
      :delete-dialog-description="DELETE_AUTH_TOKEN_DIALOG_DESCRIPTION"
      label="Authentication token"
      @rotate-or-create="rotateAuthToken"
      @delete="deleteAuthToken" />
  </SettingsRow>
</template>
